export const topics = [
  {
    key: "breaking-news",
    text: "Breaking",
    image: "/images/breaking.jpeg",
  },
  {
    key: "world",
    text: "World",
    image: "/images/world.png",
  },
  {
    key: "business",
    text: "Business",
    image: "/images/business.webp",
  },
  {
    key: "technology",
    text: "Technology",
    image: "/images/technology.jpeg",
  },
  {
    key: "entertainment",
    text: "Entertainment",
    image: "/images/entertainment.jpeg",
  },
  {
    key: "sports",
    text: "Sports",
    image: "/images/sports.jpeg",
  },
  {
    key: "science",
    text: "Science",
    image: "/images/science.jpeg",
  },
  {
    key: "health",
    text: "Health",
    image: "/images/health.jpeg",
  },
];
